
import {
  Avatar,
  Stack, 
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {  useState } from "react";
import { useTranslation } from "react-i18next";
import type { CardShareTabsProps } from "./CardShareTabs.types";
import { 
  // ButtonLink, 
  // Icon, 
  ModifyContentModal } from "../../components";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { DeleteContentModal } from "../../components/DeleteContentModal";
import {
  BodyTypography,
  OwnerNameTypography,
  TopicCardBody,
  TopicCardContainerStack,
  TopicCardMainInfo,
  TopicCardTop
} from "../../components/TopicCard/TopicCard.styles";
import { POST_TYPE, ROLES } from "../../consts";

import { useAuthStore } from "../../stores";
import {
  stringAvatar,
  useGetCreatedLabel
} from "../../utils/community";


export function CardShareTabs({
  body,
  created,
  loId,
  ownerImage,
  ownerName,
  postId,
  topicOwner
}: CardShareTabsProps) {

  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isModifyOpen, setIsModifyOpen] = useState(false);
  const userId = useAuthStore(state => state.userData?.id_user);
  const userData = useAuthStore(state => state.userData);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isModerator = userData?.roles.some(role => role === ROLES.BUSINESS_ADMIN) ;
  const isEditable =  userId && topicOwner === userId.toString() || isModerator;


  return (
    <TopicCardContainerStack
      id="topic-card-container"
      tabIndex={ 0 }
      aria-label={ t("post_of",{ name:ownerName,post:body }) }
    >
      <TopicCardTop> 
        <TopicCardMainInfo>
          <Avatar
            { ...stringAvatar(ownerName) }
            src={ ownerImage }
            sx={ {
              height: "2rem",
              width: "2rem",
              fontSize: "1rem",
              fontWeight: "500"
            } }
          />
          <Stack
            flexGrow={ 1 }
            rowGap={ "0.25rem" }
          >
            <Stack
              direction={ "row" }
              justifyContent={ "space-between" }
              alignItems={ "center" }
           
            >
              <OwnerNameTypography variant="h4">
                { ownerName }
              </OwnerNameTypography>

            </Stack>
            <Typography 
              variant="h6"
              fontSize={ "0.75rem" }
              lineHeight={ "0.938rem" }
            >
              { useGetCreatedLabel(created) }
            </Typography>
          </Stack>
        </TopicCardMainInfo>
        {
          isEditable ?
            <Stack
              position={ "absolute" }
              direction="row"
              alignItems={ "flex-end" }
              gap={ "0.5rem" }
              bottom={ isMobile ? "0.75rem" : "unset" }
              top={ isMobile ? "unset" : "0.75rem" }
              right={ "1.5rem" }
            >
              <ButtonDigited 
                typology="tertiary"
                text={ t("modify") }
                onClick={ () => setIsModifyOpen(true) }
              />
              <ButtonDigited 
                typology="tertiary"
                text={ t("delete") }
                onClick={ () => setIsDeleteOpen(true) }
              />
            </Stack>  :
            null
        } 
      </TopicCardTop> 

      <TopicCardBody>
        <BodyTypography tabIndex={ -1 } >
          { body }
        </BodyTypography>
      </TopicCardBody>
      {
        isDeleteOpen && loId ?

          <DeleteContentModal
            selectedFilter={ null }
            selectedTopic={ null }
            id={ postId }
            postType={ POST_TYPE.SHARED }
            loId={ loId }
            closeDrawer={ ()=> {
              setIsDeleteOpen(false);
            } }
            open={ isDeleteOpen }
            isModerator={ Boolean(isModerator) }

          /> :
          null
      }
      {
        isModifyOpen ?
          <ModifyContentModal
            selectedFilter={ null }
            selectedTopic={ null }
            open={ isModifyOpen }
            loId={ loId }
            onClose={ () => setIsModifyOpen(false) }
            id={ postId }
            postType={ POST_TYPE.SHARED }
            body={ body }
            closeDrawer={ () => setIsModifyOpen(false) }
          /> : null

      }
    </TopicCardContainerStack>
  );
}
